import { render } from "./BaseErrorMessage.vue?vue&type=template&id=16ba3728"
import script from "./BaseErrorMessage.vue?vue&type=script&lang=js"
export * from "./BaseErrorMessage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__